import React from "react";

interface Props {
  color?: string
}

export default ({color = '#ffffff'}: Props) => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M12 6H14V4H18V2H14V0H12V6ZM4 6V8H0V10H4V12H6V6H4ZM10 16V18H8V12H10V14H18V16H10ZM0 16V14H6V16H0ZM18 8V10H8V8H18ZM10 2H0V3.99H10V2Z" fill={color} />
</svg>
